export var View = 'div';
//# sourceMappingURL=index.js.map